import React, { useState } from "react";
import Checkbox from "../../UI/Checkbox/Checkbox";
import CenterModal from "../../UI/Modal/CenterModal";
import { sendRemoveParticipantByHostDataTrack } from "../../../shared/dataTrackFunction";
import { DISABLE, ENABLED } from "../../../constants/Constants";
import { useDispatch, useSelector } from "react-redux";
import { setIsUnableToJoinCallModalOpen, setRemoveParticipant } from "../../../reducers/common-reducer";
import { removeAllUserByHost } from "./HostControlledParticipantUtils";
import useLanguageChange from "../../../hooks/useLanguageChange";
import { LogFirebase } from "../../../services/firestore";
import { FIREBASE_EVENT_CATEGORY } from "../../../constants/FirebaseConstants";

export const RemoveAllParticipantsByHost = () => {
    const dispatch = useDispatch();
    const { removeParticipant } = useSelector((state) => state.commonReducer);
    const localisedValues = useLanguageChange();

    const closeModal = () => {
        const removeParticipantData = {
            isRemoveAllModalOpen: false,
            isRemoveModalOpen: false,
            identity: "",
            name: "",
        };
        LogFirebase(FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS, "REMOVE_ALL_PARTICIPANTS_MODAL", "CLOSE");
        dispatch(setRemoveParticipant(removeParticipantData));
    };

    const removeAllParticipants = () => {
        removeAllUserByHost();
        closeModal();
    };

    const header = (
        <>
            <h5 className='modal-title'>{localisedValues?.end_call}</h5>
            <button type='button' className='btn-close' aria-label='Close' onClick={closeModal}>
                <span className='btn-icon icon-close-light'></span>
            </button>
        </>
    );

    const body = (
        <div className='cms-modal-text'>
            <p>{localisedValues?.removing_all_participants_will_end_the_call}</p>
        </div>
    );

    const footer = (
        <div className='button-inline more-space button-inline-tb-space d-flex align-items-center'>
            <div className='button'>
                <button className='btn default-btn-link' onClick={closeModal}>
                    {localisedValues?.cancel}
                </button>
            </div>
            <div className='button'>
                <button className='btn default-btn-primary' onClick={removeAllParticipants}>
                    {localisedValues?.end_call}
                </button>
            </div>
        </div>
    );

    return (
        <CenterModal
            showModal={removeParticipant.isRemoveAllModalOpen}
            closeModal={closeModal}
            modalClass='default-modal modal-small mob-bottom-top'
            bodyClassName='default-custom-scroll'
            className='modal-dialog-centered'
            header={header}
            body={body}
            footer={footer}
            backdrop={"static"}
        />
    );
};

export const RemoveIndividualParticipantByHost = () => {
    const dispatch = useDispatch();
    const { removeParticipant } = useSelector((state) => state.commonReducer);
    const localisedValues = useLanguageChange();

    const [rejoiningChecked, setRejoiningChecked] = useState(false);

    /* handle checkbox value on check uncheck */
    const handleCheckboxOnChange = () => {
        LogFirebase(FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS, "REMOVE_Individual_PARTICIPANTS_MODAL_Checkbox", !rejoiningChecked);
        setRejoiningChecked(!rejoiningChecked);
    };

    const closeModal = () => {
        const removeParticipantData = {
            isRemoveAllModalOpen: false,
            isRemoveModalOpen: false,
            identity: "",
            name: "",
        };
        LogFirebase(FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS, "REMOVE_Individual_PARTICIPANTS_MODAL", "CLOSE");
        dispatch(setRemoveParticipant(removeParticipantData));
    };

    const header = (
        <>
            <h5 className='modal-title'>
                {localisedValues?.remove} {removeParticipant.name}
            </h5>
            <button type='button' className='btn-close' aria-label='Close' onClick={closeModal}>
                <span className='btn-icon icon-close-light'></span>
            </button>
        </>
    );

    const body = (
        <div className='cms-modal-text'>
            <p>{localisedValues?.are_you_sure_you_want_to_remove_from_this_call?.replace("<participantName>", removeParticipant.name)}</p>
        </div>
    );

    const removeIndividualParticipant = () => {
        LogFirebase(FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS, "REMOVE_Individual_PARTICIPANTS_MODAL", "Remove_TAPPED");
        setTimeout(() => {
            const rejoinStatus = rejoiningChecked ? ENABLED : DISABLE;
            sendRemoveParticipantByHostDataTrack(ENABLED, rejoinStatus, removeParticipant.identity); // removeStatus, isRejoinNotAllowed, removeIdentity
            closeModal();
        }, 10);
    };

    const footer = (
        <>
            <div className='modal-footer-checkbox'>
                <div className='checkbox default-checkbox'>
                    <label>
                        <Checkbox
                            value={rejoiningChecked}
                            onChange={handleCheckboxOnChange}
                            name='removeIndividualParticipant'
                            id='emoveIndividualParticipant'
                        />
                        <span className='for-design'></span>
                        <span className='for-text'>
                            {localisedValues?.block_from_rejoining_this_call?.replace("<participantName>", removeParticipant.name)}
                        </span>
                    </label>
                </div>
            </div>
            <div className='button-inline more-space button-inline-tb-space d-flex align-items-center'>
                <div className='button'>
                    <button className='btn default-btn-link' onClick={closeModal}>
                        {localisedValues?.cancel}
                    </button>
                </div>
                <div className='button'>
                    <button className='btn default-btn-primary' onClick={removeIndividualParticipant}>
                        {localisedValues?.remove}
                    </button>
                </div>
            </div>
        </>
    );

    return (
        <CenterModal
            showModal={removeParticipant.isRemoveModalOpen}
            closeModal={closeModal}
            modalClass='remove-participant-modal default-modal modal-small mob-bottom-top'
            bodyClassName='default-custom-scroll'
            className='modal-dialog-centered'
            header={header}
            body={body}
            footer={footer}
            backdrop={"static"}
        />
    );
};

export const UnableToJoinCallModal = () => {
    const dispatch = useDispatch();
    const { isUnableToJoinCallModalOpen } = useSelector((state) => state.commonReducer);
    const localisedValues = useLanguageChange();

    const closeModal = () => {
        dispatch(setIsUnableToJoinCallModalOpen(false));
    };

    const header = (
        <>
            <h5 className='modal-title'>{localisedValues?.unable_to_join_the_call}</h5>
            <button type='button' className='btn-close' aria-label='Close' onClick={closeModal}>
                <span className='btn-icon icon-close-light'></span>
            </button>
        </>
    );

    const body = (
        <div className='cms-modal-text'>
            <p>{localisedValues?.you_have_been_removed_from_the_call_by_the_host_and_cannot_rejoin_now}</p>
        </div>
    );

    const footer = (
        <div className='button-inline more-space button-inline-tb-space d-flex align-items-center'>
            <div className='button'>
                <button className='btn default-btn-primary' onClick={closeModal}>
                    {localisedValues?.okay_initcap}
                </button>
            </div>
        </div>
    );

    return (
        <CenterModal
            showModal={isUnableToJoinCallModalOpen}
            closeModal={closeModal}
            modalClass='default-modal modal-small mob-bottom-top'
            bodyClassName='default-custom-scroll'
            className='modal-dialog-centered'
            header={header}
            body={body}
            footer={footer}
            backdrop={"static"}
        />
    );
};
